import React, { Component } from 'react'
import Layout from '../../components/Layout'
import UserToolbar from '../../components/UserToolbar'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '@material-ui/core/Button'
import Chip from '@material-ui/core/Chip'
import RefreshIcon from '@material-ui/icons/Refresh'
import AddIcon from '@material-ui/icons/Add'
import { Link } from 'react-router-dom'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import TablePagination from '@material-ui/core/TablePagination'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table'
import api from '../../api/connectionProxy'
import { contentVectorization } from '../../api'
import { TIPOS_CONTEUDO, TIPOS_CONTEUDO_LABELS } from '../ContentVectorization/AddModal'
import VetorizacaoNav from '../../components/VetorizacaoNav'
import { STATUS_CONFIG } from '../../constants/vectorization'

const styles = (theme) => ({
  root: { padding: '16px 0' },
  filterBar: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '16px',
    padding: '8px 16px 16px',
    flexWrap: 'wrap',
  },
  filterControl: { minWidth: 160 },
  searchControl: { minWidth: 240 },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '16px',
    flexWrap: 'wrap',
    gap: '8px',
  },
  errorBox: {
    padding: '16px',
    backgroundColor: '#fff3f3',
    borderRadius: '4px',
    marginBottom: '16px',
  },
  paginationWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '4px 8px',
  },
})

class ContentsList extends Component {
  state = {
    loading: false,
    items: [],
    total: 0,
    page: 0,
    rowsPerPage: 20,
    tipoFilter: '',
    tituloFilter: '',
    error: null,
    debounce: null,
  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData = (overrides) => {
    const state = { ...this.state, ...overrides }
    const { page, rowsPerPage, tipoFilter, tituloFilter } = state

    this.setState({ loading: true, error: null })

    const params = {
      page: page + 1,
      limit: rowsPerPage,
      order_by: 'criado_em',
      order: 'desc',
    }
    if (tipoFilter) params.tipo = tipoFilter
    if (tituloFilter) params.search = tituloFilter

    api.vectorization
      .get('/api/v1/conteudos', { params })
      .then((response) => {
        const normalized = contentVectorization.normalizeConteudosListPayload(response, {
          page,
          perPage: rowsPerPage,
        })

        this.setState({
          loading: false,
          items: normalized.items,
          total: normalized.length,
          page: normalized.page,
          rowsPerPage: normalized.rowsPerPage,
        })
      })
      .catch(() => {
        this.setState({ loading: false, error: 'Erro ao buscar conteúdos vetorizados.' })
      })
  }

  handleTipoChange = (tipo) => {
    this.setState({ tipoFilter: tipo, page: 0 }, () => this.fetchData())
  }

  handleTituloChange = (titulo) => {
    this.setState({ tituloFilter: titulo, page: 0 })
    clearTimeout(this._debounce)
    this._debounce = setTimeout(() => this.fetchData({ tituloFilter: titulo, page: 0 }), 600)
  }

  handleChangePage = (event, page) => {
    this.setState({ page }, () => this.fetchData())
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page: 0 }, () => this.fetchData())
  }

  renderStatus = (status) => {
    const config = STATUS_CONFIG[status] || { label: status || '—', color: 'default' }
    return <Chip label={config.label} color={config.color} size="small" />
  }

  render() {
    const { classes } = this.props
    const { loading, items, total, page, rowsPerPage, tipoFilter, tituloFilter, error } = this.state

    return (
      <Layout toolBarRight={UserToolbar}>
        <div className={classes.root}>
          <VetorizacaoNav active="lista" />

          {/* Header */}
          <div className={classes.header}>
            <Typography variant="h6">Conteúdos Vetorizados</Typography>
            <div>
              <Button
                component={Link}
                to="/conteudos/novo?vectorizar=1"
                variant="contained"
                color="primary"
                size="small"
                style={{ marginRight: 8 }}
              >
                <AddIcon style={{ marginRight: 6, fontSize: 18 }} />
                Cadastrar conteúdo
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={() => this.fetchData()}
                disabled={loading}
              >
                <RefreshIcon style={{ marginRight: 6, fontSize: 18 }} />
                {loading ? 'Carregando...' : 'Atualizar'}
              </Button>
            </div>
          </div>

          {/* Filtros */}
          <Paper elevation={1} style={{ marginBottom: '16px' }}>
            <div className={classes.filterBar}>
              {/* Filtro por tipo */}
              <FormControl className={classes.filterControl}>
                <InputLabel htmlFor="cl-tipo-filter">Tipo</InputLabel>
                <Select
                  value={tipoFilter}
                  onChange={(e) => this.handleTipoChange(e.target.value)}
                  inputProps={{ id: 'cl-tipo-filter' }}
                >
                  <MenuItem value="">Todos os tipos</MenuItem>
                  {TIPOS_CONTEUDO.map((tipo) => (
                    <MenuItem key={tipo} value={tipo}>
                      {TIPOS_CONTEUDO_LABELS[tipo] || tipo}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Busca por título */}
              <FormControl className={classes.searchControl}>
                <InputLabel htmlFor="cl-titulo-filter">Buscar por título</InputLabel>
                <Input
                  id="cl-titulo-filter"
                  value={tituloFilter}
                  onChange={(e) => this.handleTituloChange(e.target.value)}
                  placeholder="Digite para filtrar..."
                />
              </FormControl>
            </div>
          </Paper>

          {/* Erro */}
          {error && (
            <div className={classes.errorBox}>
              <Typography color="error">
                Serviço temporariamente indisponível. Tente novamente em instantes.
              </Typography>
              <Button
                size="small"
                variant="outlined"
                color="secondary"
                onClick={() => this.fetchData()}
                style={{ marginTop: 8 }}
              >
                Tentar novamente
              </Button>
            </div>
          )}

          {/* Contagem de resultados */}
          {!loading && !error && (
            <Typography
              variant="caption"
              color="textSecondary"
              style={{ marginBottom: '8px', display: 'block' }}
            >
              {total} {total === 1 ? 'conteúdo encontrado' : 'conteúdos encontrados'}
            </Typography>
          )}

          {/* Tabela */}
          <Paper elevation={4} className="VectorizationTableWrapper">
            {loading && (
              <div style={{ display: 'flex', justifyContent: 'center', padding: '24px' }}>
                <CircularProgress />
              </div>
            )}

            <Table className="VectorizationResponsiveTable" fixedHeader width="990px">
              <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>
                  <TableHeaderColumn>Título</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '110px' }}>Tipo</TableHeaderColumn>
                  <TableHeaderColumn>Autores</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '120px' }}>Especialidade</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '60px' }}>Ano</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '120px' }}>Status</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '160px' }}>Data</TableHeaderColumn>
                </TableRow>
              </TableHeader>

              <TableBody displayRowCheckbox={false}>
                {items.length ? (
                  items.map((item, idx) => {
                    const autoresText =
                      item.autores && item.autores.length > 0
                        ? item.autores.join(', ')
                        : '--'
                    return (
                      <TableRow key={item.content_id || idx}>
                        <TableRowColumn data-label="Título">
                          <div
                            title={item.titulo}
                            style={{
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {item.titulo || '--'}
                          </div>
                        </TableRowColumn>
                        <TableRowColumn data-label="Tipo" style={{ width: '110px' }}>
                          {TIPOS_CONTEUDO_LABELS[item.tipo] || item.tipo || '--'}
                        </TableRowColumn>
                        <TableRowColumn data-label="Autores">
                          <div
                            title={autoresText}
                            style={{
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {autoresText}
                          </div>
                        </TableRowColumn>
                        <TableRowColumn data-label="Especialidade" style={{ width: '120px' }}>
                          <div
                            title={item.especialidade}
                            style={{
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {item.especialidade || '--'}
                          </div>
                        </TableRowColumn>
                        <TableRowColumn data-label="Ano" style={{ width: '60px' }}>
                          {item.ano || '--'}
                        </TableRowColumn>
                        <TableRowColumn data-label="Status" style={{ width: '120px' }}>
                          {this.renderStatus(item.status)}
                        </TableRowColumn>
                        <TableRowColumn data-label="Data" style={{ width: '160px' }}>
                          {item.criado_em
                            ? new Date(item.criado_em).toLocaleString('pt-BR')
                            : '--'}
                        </TableRowColumn>
                      </TableRow>
                    )
                  })
                ) : (
                  <TableRow>
                    <TableRowColumn>
                      <Typography
                        noWrap
                        style={{ textAlign: 'center', padding: '16px', width: '100%' }}
                      >
                        {loading
                        ? 'Carregando...'
                        : tipoFilter || tituloFilter
                        ? 'Nenhum resultado para os filtros aplicados.'
                        : 'Nenhum conteúdo vetorizado encontrado.'}
                      </Typography>
                    </TableRowColumn>
                  </TableRow>
                )}
              </TableBody>
            </Table>

            <div className={classes.paginationWrapper}>
              <TablePagination
                component="div"
                labelRowsPerPage="Itens por página"
                labelDisplayedRows={({ from, to, count }) =>
                  `Exibindo de ${from} a ${to} de ${count}`
                }
                count={total}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[20, 50, 100]}
                page={page}
                backIconButtonProps={{ 'aria-label': 'Página anterior' }}
                nextIconButtonProps={{ 'aria-label': 'Próxima página' }}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
              />
            </div>
          </Paper>
        </div>
      </Layout>
    )
  }
}

export default withStyles(styles)(ContentsList)



// WEBPACK FOOTER //
// ./src/containers/ContentsList/index.js